import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      promoCodeContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px 24px 0px 24px',
        minWidth: '100%',
        background: 'transparent'
      },
      promoCodeInnerContainer: {
        background: 'white',
        color: '#2A2A2A',
        minWidth: '100%',
        borderRadius: '8px',
        height: '879px',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        alignItems: 'flex-start',
        padding: '56px 56px 56px 56px',
        [theme.breakpoints.down('lg')]: {
          height: '1385px',
          justifyContent: 'center',
          alignItems: 'center'
        },
        [theme.breakpoints.only('lg')]: {
          height: '480px',
          padding: '25px 56px 56px 56px'
        }
      },
      promoCodeInput: {
        width: '932px',
        background: 'transparent',
        flex: 'none',
        [theme.breakpoints.down('lg')]: {
          width: '772px'
        }
      },
      promoErrorTitle: {
        fontSize: '64px',
        fontWeight: 600,
        textAlign: 'center',
        lineHeight: 1,
        margin: '0px 0px 24px 0px',
        width: '910px',
        letterSpacing: 'normal',
        fontFamily: props.fontFamily,
        [theme.breakpoints.down('lg')]: {
          width: '800px'
        }
      },
      promoErrorDescription: {
        fontSize: '30px',
        textAlign: 'center',
        letterSpacing: 'normal',
        width: '710px',
        fontFamily: props.fontFamily,
        [theme.breakpoints.down('lg')]: {
          width: '600px'
        }
      },
      promoTitle: {
        flex: 'none',
        background: 'transparent',
        margin: '0px 32px 32px 32px',
        lineHeight: 1,
        [theme.breakpoints.only('lg')]: {
          margin: '0px 32px 0px 32px'
        }
      },
      promoDescription: {
        margin: '0px 0px 50px 0px',
        [theme.breakpoints.only('lg')]: {
          margin: '0px 0px 25px 0px'
        }
      },
      promoCodeKeyboardBox: {
        '& > * ': {
          [theme.breakpoints.only('lg')]: {
            height: '480px'
          }
        }
      }
    })
  );
